'use client'

import { Reveal } from '../Reveal'
import { CheckIcon } from '../Icons'
import { aboutImage } from '@/lib/site-config'

const points: string[] = [
  'أعمال البناء والتشطيب والترميم',
  'تنفيذ المشاريع بإشراف واهتمام بالتفاصيل',
  'الالتزام باحتياجات العميل ودقة التنفيذ',
]

export function About(): React.ReactElement {
  return (
    <section id="about" className="section-pad relative overflow-hidden bg-charcoal-950">
      <div className="container-x grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        {/* Image */}
        <Reveal className="order-2 lg:order-1">
          <div className="relative">
            <div className="absolute -inset-3 rounded-3xl bg-gold-500/10 blur-2xl" />
            <div className="relative overflow-hidden rounded-3xl border border-white/10">
              <img
                src={aboutImage}
                alt="فريق العمل في موقع البناء"
                className="h-full w-full object-cover"
                loading="lazy"
              />
            </div>
            {/* Floating slogan card */}
            <div className="absolute -bottom-6 right-6 hidden rounded-2xl bg-gold-gradient px-6 py-4 shadow-gold sm:block">
              <p className="font-heading text-lg font-extrabold text-charcoal-950">
                نبني بثقة
              </p>
              <p className="text-sm font-bold text-charcoal-900">وننجز بجودة</p>
            </div>
          </div>
        </Reveal>

        {/* Text */}
        <div className="order-1 lg:order-2">
          <Reveal>
            <span className="eyebrow mb-5">من نحن</span>
            <h2 className="title-accent font-heading text-3xl font-extrabold text-white sm:text-4xl md:text-5xl">
              نشاط مقاولات يمني ناشئ
            </h2>
          </Reveal>

          <Reveal delay={0.1}>
            <p className="mt-8 text-lg leading-relaxed text-charcoal-200">
              أبو صالح النييفي للمقاولات نشاط مقاولات يمني ناشئ يركز على أعمال البناء والتشطيب
              والترميم وتنفيذ المشاريع، مع الحرص على جودة العمل ودقة التفاصيل والالتزام
              باحتياجات العميل.
            </p>
          </Reveal>

          <Reveal delay={0.2}>
            <ul className="mt-8 space-y-4">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <span className="mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gold-500/15 text-gold-300">
                    <CheckIcon className="h-4 w-4" />
                  </span>
                  <span className="text-charcoal-100">{p}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  )
}
